import { render, staticRenderFns } from "./ChangeLocation.vue?vue&type=template&id=ebefeac4"
import script from "./ChangeLocation.vue?vue&type=script&lang=js"
export * from "./ChangeLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports